import $ from 'jquery';
import { Modal } from 'bootstrap';
import Swiper from 'swiper/bundle';

export default function avuMessagesModal() {

    if(document.getElementById('avuProblemsMessagesModal') != null ) {
        let myProblemsModalEl = document.getElementById('avuProblemsMessagesModal');
        let myModalProblems = new Modal(myProblemsModalEl);
        $('.open-avu-problems-messages-modal').click(function (e) {
            e.preventDefault();
            if(myModalProblems) {
                myModalProblems.show();
            }

        });
        $('.open-avu-problems-messages-modal').click(function (e) {
            e.preventDefault();
            if(myModalProblems) {
                myModalProblems.hide();
            }
        });
    }

    if(document.getElementById('avuMessagesModal') != null ) {
        let myModalEl = document.getElementById('avuMessagesModal');
        let myModal = new Modal(myModalEl);
        $('.open-avu-messages-modal').click(function (e) {
            e.preventDefault();
            myModal.show();
        });
        $('.avu-messages-modal-close').click(function (e) {
            e.preventDefault();
            myModal.hide();
        });
        let swiperAvuMessages = new Swiper(".avu-messages-modal-swiper", {
            slidesPerView: 1,
            spaceBetween: 40,
            loop: true,
            pagination: {
                el: ".avu-messages-modal-swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".avu-messages-modal-swiper-next",
                prevEl: ".avu-messages-modal-swiper-prev",
            },
        });
    }

    if(document.getElementById('avuLoadModal') != null ) {
        let myModalEl = document.getElementById('avuLoadModal');
        if(myModalEl) {
            let myModal = new Modal(myModalEl);
            myModal.show();
        }
        $('.avu-messages-modal-close').click(function (e) {
            e.preventDefault();
            myModal.hide();
        });
        let swiperAvuOnLoadModal = new Swiper(".avu-onload-modal-swiper", {
            slidesPerView: 1,
            spaceBetween: 40,
            loop: true,
            pagination: {
                el: ".avu-onload-modal-swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".avu-onload-modal-swiper-next",
                prevEl: ".avu-onload-modal-swiper-prev",
            },
        });
    }


}